module.exports = __webpack_public_path__ + "static/media/features-collect-image.adf1f94c.jpg";